import { render, staticRenderFns } from "./CompanyAccountsList.vue?vue&type=template&id=771ac5ec&"
import script from "./CompanyAccountsList.vue?vue&type=script&lang=js&"
export * from "./CompanyAccountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports